module.exports = __webpack_public_path__ + "static/media/arena3.866d0ff2.png";